import React, { Component } from 'react';
import { GoogleMap, GoogleMapLoader, Marker, InfoWindow } from "react-google-maps";

class FittersMap extends Component {

    handleMarkerClick(marker){
        return () => {
            try {
               this.props.selectMarker(marker);
            } catch(error) {
                console.log(error);
            }
        }
    }

    closeInfoWindow(){
        // action here
    }

    renderInfoWindow(ref, marker){

        return (
            <InfoWindow key={`${ref}_info_window`} onCloseClick={ this.closeInfoWindow(marker)}>
                <div style={{ color: '#000'}}>
                    <strong>{ marker.first } { marker.last }</strong> <br/>
                    Phone: { marker.phone } <br/>
                    E-mail: { marker.email } <br/>
                    Address: {marker.addr1} { marker.city } <br/>
                </div>
            </InfoWindow>
        )
    }

    render() {
        const { markers, selectedMarker, currentLocation } = this.props;
        
        if(Object.keys(currentLocation).length <= 0) {
            return null;
        }

        const { latitude, longitude } = currentLocation;


        return (
            <GoogleMapLoader
                containerElement={
                    <div style={{ height: "100%" }} />
                }
                googleMapElement={
                    <GoogleMap
                    defaultZoom={5}
                    defaultCenter={{lat: parseFloat(latitude), lng: parseFloat(longitude) }}
                    onClick={this.handleMapClick}>

                        { markers.map((marker, index) => {
                            const ref = `marker_${index}`;

                            return (
                                <Marker 
                                    key={ref} 
                                    ref={ref}
                                    position={marker.position}
                                    title={(index + 1).toString()}
                                    onClick={this.handleMarkerClick(marker)}>


                                    { selectedMarker.id === marker.id ? this.renderInfoWindow(ref, marker) : null }

                                </Marker>
                            )
                        })}

                    </GoogleMap>
                }
            />
        );
    }
}

export default FittersMap;



// WEBPACK FOOTER //
// ./src/fitters-locator/components/FittersMap.js